export default "__VITE_ASSET__DFASn8va__"